export const Operations = {
    addition: "ADDITION_OP",
    substraction: "SUBSTRACTION_OP",
    multiplication: "MULTIPLICATION_OP",
    division: "DIVISION_OP",
    negate: "NEGATE_OP",
    assign: "ASSIGN_OP",
    predecrement: "PREDECREMENT_OP",
    postdecrement: "POSTDECREMENT_OP"
};